export function healthFacilityLabel(hf) {
  return !!hf ? `${hf.code} ${hf.name}` : "";
}

export function locationLabel(l, options = {}) {
  if (!l) return "";
  if (options.nameOnly) {
    return l.name ?? "";
  }
  return `${l.code ?? ""} ${l.name ?? ""}`.trim();
}

export const LOCATION_SUMMARY_PROJECTION = ["id", "uuid", "code", "name", "type"];

export const nestParentsProjections = (i) => {
  return `parent{${LOCATION_SUMMARY_PROJECTION}${i === 0 ? "" : "," + nestParentsProjections(i - 1)}}`;
};
